import * as React from 'react';
import { AcceptSharePointInviteProps } from '../types';

const AcceptSharePointInvite: React.FC<AcceptSharePointInviteProps> = ({ onComplete, onReject }) => {
  const [isAccepting, setIsAccepting] = React.useState<boolean>(false);
  const [isRejecting, setIsRejecting] = React.useState<boolean>(false);
  const [error, setError] = React.useState<string | null>(null);

  const handleAccept = (): void => {
    setIsAccepting(true);
    setError(null);
    
    // Simulate API call to accept invitation
    setTimeout(() => {
      try {
        console.log("SharePoint invitation accepted");
        setIsAccepting(false);
        
        // Move to next step (Complete)
        onComplete();
      } catch (err) {
        console.error("Error accepting invitation:", err);
        setError("Failed to accept invitation. Please try again.");
        setIsAccepting(false);
      }
    }, 1000);
  };

  const handleReject = (): void => {
    setIsRejecting(true);
    
    // Simulate API call to reject invitation
    setTimeout(() => {
      console.log("SharePoint invitation rejected");
      setIsRejecting(false);
      onReject();
    }, 1000);
  };

  return (
    <div className="step-content">
      <h2>Accept KCNSC O365 Invitation</h2>
      <p>You've been invited to access KCNSC O365 resources. Would you like to accept?</p>
      <p><a href="https://kcnsc.doe.gov" target='blank' >Terms of Use</a>&nbsp;&nbsp;&nbsp;<a href="https://kcnsc.doe.gov" target='blank' >Legal Notice</a></p>
      {error && (
        <div className="error-message">
          {error}
        </div>
      )}
      
      <div className="button-group">
        <button 
          className="primary-button" 
          onClick={handleAccept}
          disabled={isAccepting || isRejecting}
        >
          {isAccepting ? 'Processing...' : 'Accept O365 Access'}
        </button>
        <button 
          className="secondary-button" 
          onClick={handleReject}
          disabled={isAccepting || isRejecting}
        >
          {isRejecting ? 'Processing...' : 'Decline Access'}
        </button>
      </div>
    </div>
  );
};

export default AcceptSharePointInvite;